module.exports = __webpack_public_path__ + "assets/img/touxiang.62bb978e.png";